// Utils/product-availability.js

export const PRODUCT_AVAILABILITY = {
  EOL: "EOL",
  AVAILABLE: "AVAILABLE",
  DISPONIBLE: "DISPONIBLE",
};

export const normalizeAvailability = (value) =>
  String(value || "").trim().toUpperCase();

export const getProductAvailabilityValues = (product) => {
  if (!product) return [];

  return [
    product.availabilityStatus,
    product.availability,
    product.availabilityEN,
    product.availabilityFR,
  ]
    .map(normalizeAvailability)
    .filter(Boolean);
};

export const productHasAvailabilityValue = (product, availabilityValues = []) => {
  const normalizedAvailabilityValues = availabilityValues.map(normalizeAvailability);
  const productAvailabilityValues = getProductAvailabilityValues(product);

  return productAvailabilityValues.some(value =>
    normalizedAvailabilityValues.includes(value)
  );
};

export const isEolProduct = (product) => {
  return productHasAvailabilityValue(product, [
    PRODUCT_AVAILABILITY.EOL,
  ]);
};

export const isAvailableProduct = (product) => {
  return productHasAvailabilityValue(product, [
    PRODUCT_AVAILABILITY.AVAILABLE,
    PRODUCT_AVAILABILITY.DISPONIBLE,
  ]);
};

export const isBrowsableProduct = (product) => {
  return !isEolProduct(product);
};

export const filterBrowsableProducts = (products = []) => {
  return products.filter(isBrowsableProduct);
};

export const canAddProductToList = (product) => {
  return !isEolProduct(product);
};

export const isComingSoonProduct = (product) => {
  const availabilityValues = getProductAvailabilityValues(product);

  if (availabilityValues.length === 0) {
    return false;
  }

  return !isEolProduct(product) && !isAvailableProduct(product);
};

export const filterComingSoonProducts = (products = []) => {
  return products.filter(isComingSoonProduct);
};